<template>
  <div>
    <h1
      class="font-[Inter] text-[1.25rem] md:text-[1.5rem] lg:text-[1.75rem] leading-[2rem] md:leading-[2.5rem] lg:leading-[3rem] text-white font-black tracking-[-0.03em]"
    >
      Downloadables
    </h1>
    <BaseSwiper
      :id="baseSwiperId"
      :ref="baseSwiperId"
      v-slot="slotProps"
      :items="items"
      :options="AUTO_SCROLL"
      class="mt-[16px] md:mt-[20px] overflow-x"
    >
      <CardTile
        class="border-[0px] drop-shadow-tile relative flex flex-col w-[160px] md:w-[200px] lg:w-[240px] h-[189.15px] md:h-[236px] lg:h-[283px] rounded-[12px] shrink-0"
        :image-src="slotProps.item.imageSrc"
        :is-downloadable="true"
        @click="$emit('download', slotProps.item.dataEventTracking)"
      />
    </BaseSwiper>
  </div>
</template>

<script>
import BaseSwiper from '@/components/design/BaseSwiper.vue';
import CardTile from '@/components/design/CardTile.vue';
import { AUTO_SCROLL } from '@/utils/swiper-presets';

export default {
  components: {
    BaseSwiper,
    CardTile,
  },
  props: {
    baseSwiperId: {
      type: String,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return { AUTO_SCROLL };
  },
  emits: ['download'],
};
</script>
